import Cookies from 'js-cookie';
import api from "./api";
import {toast} from "react-toastify";

export const getMyInfo = async () => {
    const token = Cookies.get('token');
    if (!token) {
        toast.error('دوباره وارد شوید');
        setTimeout(() => {
            window.location.href = '/login';
        }, 2000);
    }

    try {
        return await api.get('/my-info', {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
    } catch (error) {
        if (error.response && error.response.status === 401) {
            toast.error('دوباره وارد شوید');
            Cookies.remove('token');
            Cookies.remove('info');
            setTimeout(() => {
                // window.location.href = '/login';
            }, 2000);
        } else {
            Cookies.remove('token');
            Cookies.remove('info');
            toast.error('مشکلی پیش آمده');
            setTimeout(() => {
                window.location.href = '/login';
            }, 2000);
        }
    }
};
